import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import { BLOG_POSTS } from "../data/products";

export default function Blog() {
  const [feature, ...rest] = BLOG_POSTS;
  return (
    <>
      <PageHeader
        eyebrow="The Trade Journal"
        title="Insights for the global spice trade."
        italicWord="global"
        subtitle="Long-form articles for importers, private label brands and food-industry buyers — written by people who work in the trade, not around it."
      />

      {/* FEATURE */}
      <section className="py-24 bg-brand-ivory">
        <div className="container-luxe">
          <Reveal>
            <Link to={`/blog/${feature.slug}`} className="group grid lg:grid-cols-12 gap-10 items-center" data-testid={`blog-feature-${feature.slug}`}>
              <div className="lg:col-span-7 relative aspect-[16/10] overflow-hidden bg-brand-ink">
                <img src={feature.cover} alt="" className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-[900ms]" />
                <div className="absolute inset-0 bg-brand-ink/25" />
              </div>
              <div className="lg:col-span-5">
                <div className="text-[11px] tracking-[0.24em] uppercase text-brand-gold mb-3">{feature.category} · {feature.read_time}</div>
                <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] text-brand-charcoal group-hover:text-brand-green transition-colors">{feature.title}</h2>
                <p className="mt-6 text-brand-charcoal/65 text-[16px] leading-relaxed">{feature.excerpt}</p>
                <div className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase text-brand-green font-semibold">
                  Read article <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          </Reveal>
        </div>
      </section>

      {/* GRID */}
      <section className="py-16 md:py-24 bg-brand-ivory-warm">
        <div className="container-luxe">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {rest.map((post, i) => (
              <Reveal key={post.slug} delay={i * 80}>
                <Link to={`/blog/${post.slug}`} className="group block" data-testid={`blog-card-${post.slug}`}>
                  <div className="relative aspect-[4/3] overflow-hidden bg-brand-ink mb-6">
                    <img src={post.cover} alt="" className="w-full h-full object-cover opacity-85 group-hover:scale-105 transition-transform duration-[900ms]" />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/60 to-transparent" />
                    <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-brand-ivory">
                      <span className="text-[10px] tracking-[0.24em] uppercase">{post.category}</span>
                      <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                  <div className="text-[11px] tracking-[0.24em] uppercase text-brand-charcoal/45 mb-3">{post.date} · {post.read_time}</div>
                  <h4 className="font-serif text-2xl leading-snug text-brand-charcoal group-hover:text-brand-green transition-colors">{post.title}</h4>
                  <p className="mt-3 text-brand-charcoal/60 text-[14.5px] leading-relaxed line-clamp-3">{post.excerpt}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
